import { styled } from '@mui/material/styles';
import { TableCell, TableRow } from '@mui/material';

export const HeadingCell = styled(TableCell)`
  font-weight: 600;
  white-space: nowrap;
`;

export const StyledTableRow = styled(TableRow)`
  background-color: #f4f4f4;
  position: sticky;
  top: 0;
`;